
import Form from '@/ui-kit/components/form';
import FormField from '@/ui-kit/components/form/form-field';
import LayoutGridContainer from '@/ui-kit/components/layout-grid/container';
import LayoutGridItem from '@/ui-kit/components/layout-grid/item';
import { LayoutItemProperty, LayoutItemColumn } from '@/ui-kit/components/layout-grid/item/enums';
import { LayoutContainerProperty } from '@/ui-kit/components/layout-grid/container/enums';
import { StyleSizeType } from '@/ui-kit/styles/enums';
import { InputFillType } from '@/ui-kit/components/form/controls/shared/input/enums';
import { FormFieldProperty } from '@/ui-kit/components/form/enums';
import { SelectProperty } from '@/ui-kit/components/form/controls/components/select/enums';
import { ControlType, ControlEventType } from '@/ui-kit/components/form/controls/enums';
import {
  AutocompleteFilterStrategy,
  AutocompleteFilterType,
  AutocompleteProperty,
} from '@/ui-kit/components/form/controls/components/autocomplete/enums';
import AddressDictionaries from '../../../../../../shared/forms/address/mixins/AddressDictionaries';
import BaseForm from '../../mixins/BaseForm';
import { LocationFormControlName } from './enums';
import { LOCATION_DEFAULT_VALUES, PROVINCE_OPTIONS } from './constants';

export default {
  name: 'LocationForm',
  components: {
    LayoutGridItem,
    LayoutGridContainer,
    Form,
    FormField,
  },
  mixins: [AddressDictionaries, BaseForm],
  data() {
    return {
      LocationFormControlName,
      FormFieldProperty,
      LayoutItemProperty,
      LayoutItemColumn,
      LayoutContainerProperty,
      StyleSizeType,
      ControlType,
      ControlEventType,
    };
  },
  computed: {
    communityControl() {
      return this.getControl(LocationFormControlName.Community);
    },
    cityControl() {
      return this.getControl(LocationFormControlName.City);
    },
    provinceControl() {
      return this.getControl(LocationFormControlName.Province);
    },
    province() {
      return this.provinceControl?.value;
    },
    city() {
      return this.cityControl?.value;
    },
    communityInputProps() {
      return {
        [AutocompleteProperty.Name]: LocationFormControlName.Community,
        [AutocompleteProperty.FillType]: InputFillType.Underlined,
        [AutocompleteProperty.FilterStrategy]: AutocompleteFilterStrategy.Sync,
        [AutocompleteProperty.Options]: this.communitiesOptions,
        [AutocompleteProperty.Label]: 'Community',
        [AutocompleteProperty.IsLoading]: this.areAddressDictionariesLoading,
        [AutocompleteProperty.Disabled]: !this.city,
        [AutocompleteProperty.FilterType]: AutocompleteFilterType.StartsWith,
      };
    },
    cityInputProps() {
      return {
        [AutocompleteProperty.Name]: LocationFormControlName.City,
        [AutocompleteProperty.FillType]: InputFillType.Underlined,
        [AutocompleteProperty.FilterStrategy]: AutocompleteFilterStrategy.Sync,
        [AutocompleteProperty.Options]: this.citiesOptions,
        [AutocompleteProperty.Label]: 'City',
        [AutocompleteProperty.IsLoading]: this.areAddressDictionariesLoading,
        [AutocompleteProperty.Disabled]: !this.province,
        [AutocompleteProperty.FilterType]: AutocompleteFilterType.StartsWith,
      };
    },
    provinceInputProps() {
      return {
        [SelectProperty.Name]: LocationFormControlName.Province,
        [SelectProperty.FillType]: InputFillType.Underlined,
        [SelectProperty.Label]: 'Province',
        [SelectProperty.Options]: PROVINCE_OPTIONS,
      };
    },
  },
  watch: {
    province(value) {
      this.loadAddressDictionaries(value);
    },
  },
  mounted() {
    this.loadAddressDictionaries(this.province);
  },
  methods: {
    async loadAddressDictionaries(province) {
      if (province) {
        await this.getAddressDictionaries(province);
      }
    },
    handleProvinceChange() {
      this.cityControl.setValue(LOCATION_DEFAULT_VALUES[LocationFormControlName.City]);
      this.communityControl.setValue(LOCATION_DEFAULT_VALUES[LocationFormControlName.Community]);
    },
  },
};
